@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides

import com.narbase.letsgo.router.EndPoint

object GetOngoingRidesEndpoint : EndPoint<GetOngoingRidesEndpoint.Request, GetOngoingRidesEndpoint.Response>() {
    class Request

    class Response(
        val list: Array<PassengerRideDto>
    )
}